// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel_label__2vJuI","error":"InputLabel_error__2YZZf"};